import { makeStyles } from '@material-ui/core/styles';

export const useInstructionStyles = makeStyles(() => ({
  image: {
    height: 30,
    width: 24,
  },
  container: {
    marginBottom: 12,
  },
  text: {
    fontSize: 16,
  },
}));
